import { ListMyTasksResponseSchema } from './list-my-tasks.schema';
/**
 * List My Tasks Endpoint Contract
 * The open tasks assigned to the caller.
 */ export const listMyTasksContract = {
    method: 'GET',
    path: '/api/v2/task/mine',
    description: 'List the open tasks assigned to the current user',
    responseSchema: ListMyTasksResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user may not read tasks'
        }
    }
};

//# sourceMappingURL=list-my-tasks.contract.js.map